export const iconFontAwesomeTransportationPlane = (
	<i className="fa-solid fa-plane"></i>
);
